const fixedCta = (): void => {
  const fixedCta: HTMLElement | null = document.querySelector('.p-fixed-cta');

  // スクロールが発生したら「.is-hidden」クラスを追加
  // スクロールをやめて0.2秒後に「.is-hidden」クラスを削除
  let scrollY: number = 0;
  let timer: any = 0;
  window.addEventListener('scroll', () => {
    clearTimeout(timer);
    if (scrollY < window.scrollY) {
      fixedCta?.classList.add('is-hidden');
    } else {
      fixedCta?.classList.remove('is-hidden');
    }
    scrollY = window.scrollY;
    timer = setTimeout(() => {
      fixedCta?.classList.remove('is-hidden');
    }, 200);
  });
};

export default fixedCta;
